import React, {useContext} from 'react';
import Head from 'next/head';

import {SitemapContext} from '~/src/components/context/SitemapContext';
import {getStructuredContentBreadcrumbs} from '~/src/utilities/helpers/structuredData';

const StructuredBreadcrumbsContent = (props) => {
    const {all} = useContext(SitemapContext);

    const structuredData = getStructuredContentBreadcrumbs(props, all);
    const html = JSON.stringify(structuredData);

    return (
        <Head>
            <script key="breadcrumbsStructuredData" type="application/ld+json" dangerouslySetInnerHTML={{__html: html}}></script>
        </Head>
    );
};

export default StructuredBreadcrumbsContent;
